export const pageLayout = {
  px: {
    xs: "24px",
    md: "48px",
    lg: "0",
  },
  mx: {
    lg: "auto",
  },
  width: {
    xs: "100%",
    lg: "896px",
    xl: "1120px",
  },
};
